import { useIsLoggedInQuery } from '../queries/useGetIsLoggedInQuery.ts';
import { useLocation, useNavigate } from 'react-router-dom';
import { rememberReturnPath } from '../../utils/returnPath';
import { useEffect } from 'react';

type IsLoggedInRedirectHookResult = {
  isLoggedInData: { isLoggedIn: boolean } | undefined;
  isLoadingIsLoggedIn: boolean;
  hasIsLoggedInError?: Error | null;
};

export const useIsLoggedInRedirect = (): IsLoggedInRedirectHookResult => {
  const {
    data: isLoggedInData,
    error,
    isPending,
    isFetching,
  } = useIsLoggedInQuery();
  const navigate = useNavigate();
  const location = useLocation();
  const isLoadingIsLoggedIn = isPending || isFetching;
  const isLoggedIn = isLoggedInData?.isLoggedIn ?? false;

  useEffect(() => {
    if (!isLoggedIn && !isFetching) {
      // The page opens after the login, such as a link from an email
      rememberReturnPath(location.pathname + location.search + location.hash);
      navigate('/', { replace: true });
    }
  }, [isLoggedIn, isFetching, navigate, location]);

  return { isLoggedInData, isLoadingIsLoggedIn, hasIsLoggedInError: error };
};
